var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13976",
    "data-name": "Group 13976",
    transform: "translate(-2300 -325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 36,
    height: 36,
    rx: 4,
    transform: "translate(2300 325)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(2311 334.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 2.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M.375,29.7a.406.406,0,0,1,.375.432V32.29a.813.813,0,0,0,.75.863h9a.813.813,0,0,0,.75-.863V30.132a.379.379,0,1,1,.75,0V32.29a1.625,1.625,0,0,1-1.5,1.727h-9A1.625,1.625,0,0,1,0,32.29V30.132A.406.406,0,0,1,.375,29.7Z",
    transform: "translate(1 -22.016)",
    fill: "#34303a",
    stroke: "#34303a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M16.251,3.124a.442.442,0,0,1,.62,0L19.5,5.714a.428.428,0,0,1,0,.611.442.442,0,0,1-.62,0L17,4.472v7.591a.438.438,0,0,1-.875,0V4.472L14.246,6.325a.442.442,0,0,1-.62,0,.428.428,0,0,1,0-.611Z",
    transform: "translate(-9.561 -2.997)",
    fill: "#34303a",
    stroke: "#34303a",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/uploadImg.4b554607eb28cc4ffcaae86a91996e7a.svg";
export { ForwardRef as ReactComponent };